import styled from 'styled-components';
import { Divider, Form, Input, Radio } from 'antd';

import SvgIcon from '../../../components/svg-icon/';
import ButtonWithLoader from '../../../components/ui-helpers/button-with-loader';
import { tangerineGradient, tangerineGradientRevert } from '../../../styles';


export const FormS = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 20px auto;
  width: 100%;
`;

export const FormItemS = styled(Form.Item)`
  width: 100%;
`;

export const AddUserButton = styled(ButtonWithLoader)`
  color: ${props => props.theme.colors.white};
  width: 153px;
  height: 36px;  
  border: none;
  border-radius: 4px;
  ${tangerineGradient};
  
  &:hover,
  &:focus {
    ${tangerineGradientRevert};
  }
`;

export const InputS = styled(Input)`
  height: 50px;
  
  input {
    border-color: ${props => props.theme.colors.tangerineSecond};
    border-radius: 0;
    padding-left: 40px !important;
    font-family: 'Rubik',sans-serif;
    font-size: 14px;
  }
`;

export const IconS = styled(SvgIcon)`
  margin-right: 11px;
`;

export const UserName = styled.div`
  margin-right: 7px;
  font-size: 15px;
  color: ${props => props.theme.colors.fontDark};
`;

export const DividerS = styled(Divider)`
  width: calc(100% + 48px);
  margin: 20px -24px 13px -24px;
`;

export const RadioS = styled(Radio)`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: 78px;

  :not(:last-of-type) {
    margin-right: 25px;
  }

  input[type='radio']:after {
    content: '';
    display: inline-block;
    border-radius: 16px;
    width: 16px;
    height: 16px;
    top: -1px;
    left: -1px;
    position: relative;
    background-color: #d1d3d1;
    visibility: visible;
    border: 2px solid #fff;
    transition: all 300ms ease;
  }

  input[type='radio']:checked:after {
    content: '';
    display: inline-block;
    border-radius: 16px;
    width: 16px;
    height: 16px;
    top: -1px;
    left: -1px;
    position: relative;
    background-color: #ff9900;
    visibility: visible;
    border: 2px solid #fff;
  }
`;

export const RadioGroupS = styled(Radio.Group)`
  background-color: #f5f5f5;
  margin-bottom: 8px;
  padding: 8px;
`;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/invite-user-form/styled-components.js